import { Environment } from '@mybitzer/core/environment.token'

export const environment: Environment = {
  backoffice: true,
  production: false,
  logrocket: true,
  logrocketAppID: 'd1y2gb/bdn-dev',
  embedded: false,
  googleAnalyticsId: 'G-YRPWB5EZ4C',
  keycloak: {
    url: 'https://auth.dev.mybitzer.de/auth',
    realm: 'bdn',
    clientId: 'mybitzer-backoffice-app'
  },
  featureFlags: {},
  tabOrder: {},
  cnEnergyView: false,
  packageExpiryWarningDays: 30,
  isChina: false,
  availableLanguages: [
    { code: 'en', label: 'English' },
    { code: 'de', label: 'Deutsch' }
  ],
  langCookieName: 'boffice_userlang',
  materialIconsClass: 'material-symbols-outlined-fill',
  cartoApiKey: ''
}
